import { emptyObject } from 'ui-components/default-props/empty';
import { IS_SMARTFILL_APPLIED, SMARTFILL_DATA, MAX_SHIPMENTS_WITH_SMARTFILL_APPLIED_FOR_BANNER_DISPLAY } from './constant';
import { useEntitiesFulfillmentPlanProperty } from '../entities/selectors/fulfillment-plans';
import {
  useShouldSmartFillOverwriteMarketplaceWeight,
  useTotalOrderWithSmartFillApplied,
  useIsSmartFillWeightEnabled,
  useIsSmartFillSizeEnabled,
  useIsSmartFillPackageEnabled,
  useIsSmartFillHashKeyManagementEnabled,
} from '../use-seller-setting';
import { SellerSettings } from '../../enums/seller-settings/seller-settings';

export const useSmartFillData = (fulfillmentPlanId) => {
  const isSmartFillApplied = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, IS_SMARTFILL_APPLIED);
  const smartFillData = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, SMARTFILL_DATA);
  const appliedSmartFillData = isSmartFillApplied ? JSON.parse(smartFillData) : emptyObject;

  if (appliedSmartFillData) {
    return Object.fromEntries(
      Object.entries(appliedSmartFillData).map(([key, value]) => [
        key,
        value.Status === 1 && value.Value !== '' ? parseFloat(value.Value) : null, // Ensure every key exists
      ]),
    );
  }

  return {};
};

export const useSmartFillMetaData = (fulfillmentPlanId) => {
  const isSmartFillApplied = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, IS_SMARTFILL_APPLIED);
  const smartFillData = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, SMARTFILL_DATA);

  return isSmartFillApplied && smartFillData ? JSON.parse(smartFillData) : emptyObject;
};

export const useShouldDisplaySmartFillBanner = (fulfillmentPlanId) => {
  const totalShipmentsWithSmartFillApplied = useTotalOrderWithSmartFillApplied();
  const isSmartFillApplied = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, IS_SMARTFILL_APPLIED);

  return isSmartFillApplied ? totalShipmentsWithSmartFillApplied < MAX_SHIPMENTS_WITH_SMARTFILL_APPLIED_FOR_BANNER_DISPLAY : false;
};

export const useGetSmartFillConfigurationData = () => {
  const totalShipmentsWithSmartFillApplied = useTotalOrderWithSmartFillApplied();
  const shouldSmartFillOverwriteMarketplaceWeight = useShouldSmartFillOverwriteMarketplaceWeight();
  const isSmartFillWeightEnabled = useIsSmartFillWeightEnabled();
  const isSmartFillSizeEnabled = useIsSmartFillSizeEnabled();
  const isSmartFillPackageEnabled = useIsSmartFillPackageEnabled();
  const isSmartFillHashKeyManagementEnabled = useIsSmartFillHashKeyManagementEnabled();

  return {
    [SellerSettings.shouldSmartFillOverwriteMarketplaceWeight.key]: shouldSmartFillOverwriteMarketplaceWeight,
    [SellerSettings.totalOrderWithSmartFillApplied.key]: totalShipmentsWithSmartFillApplied,
    [SellerSettings.isSmartFillWeightEnabled.key]: isSmartFillWeightEnabled,
    [SellerSettings.isSmartFillSizeEnabled.key]: isSmartFillSizeEnabled,
    [SellerSettings.isSmartFillPackageEnabled.key]: isSmartFillPackageEnabled,
    [SellerSettings.isSmartFillHashKeyManagementEnabled.key]: isSmartFillHashKeyManagementEnabled,
  };
};
